<template>
	<div class="d-flex" style="white-space: nowrap">
		<v-menu offset-y content-class="grv-menu" max-height="400px">
			<template v-slot:activator="{ on }">
				<v-btn
					v-if="jd_type_selected"
					:loading="loading"
					v-on="on"
					class="text-none mr-0 black--text mx-2 my-0 typed-btn"
					:style="getStyle(jd_type_selected, 'background')">
					{{ jd_type_selected.text }}
				</v-btn>
				<v-btn
					v-else
					v-on="on"
					title="Filter par type de workflow"
					:disabled="jds_types.length === 0"
					class="text-none mx-2 my-0 type-btn"
					color="background darken-1">
					<v-icon large class="mr-2">filter_list</v-icon>
					Type
				</v-btn>
			</template>
			<v-list dense class="pa-0 background darken-1">
				<template v-for="jd_type in jds_types">
					<v-list-tile
						:key="jd_type.text"
						v-if="!typeIsSelected(jd_type.value)"
						:style="getStyle(jd_type, 'border')"
						class="pl-2"
						@click="$emit('change', jd_type)">
						<v-list-tile-title>
							{{ jd_type.text }}
						</v-list-tile-title>
					</v-list-tile>
				</template>
			</v-list>
		</v-menu>
		<v-btn
			v-if="jd_type_selected && !loading"
			flat icon
			large
			class="ma-0"
			:style="getStyle(jd_type_selected, 'color')"
			@click="$emit('change', null)">
			<v-icon large>close</v-icon>
		</v-btn>
	</div>
</template>

<script>
export default {
	props: [ 'jds_types', 'jd_type_selected', 'loading' ],
	methods: {
		getStyle (jdType, style) {
			let color = this.$colors.stringToHsl(jdType.text, 70)
			if (style === 'background') {
				return `background-color: ${color}`
			} else if (style === 'color') {
				return `color: ${color}`
			} else if (style === 'border') {
				return `border-left: 4px solid ${color};
								border-top: 0.5px solid ${color};
								color: ${color}`
			}
			return ''
		},
		typeIsSelected (typeValue) {
			if (!this.jd_type_selected) return false
			return this.jd_type_selected.value === typeValue
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_types_menu.vue